import { render, staticRenderFns } from "./CityRoomCard.vue?vue&type=template&id=33a28e60&scoped=true&"
import script from "./CityRoomCard.vue?vue&type=script&lang=js&"
export * from "./CityRoomCard.vue?vue&type=script&lang=js&"
import style0 from "./CityRoomCard.vue?vue&type=style&index=0&id=33a28e60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a28e60",
  null
  
)

export default component.exports